import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export function clientePfService() {
	const api = useApi()

	async function getClientesPf(params = {}) {
		return await api.query(`${window.origin}${URLS.api_clientepf}`, params)
	}

	async function getInformacoesClientePf(clienteId = '') {
		return await api.query(`${window.origin}${URLS.api_clientepf}${clienteId}`)
	}

	return { getClientesPf, getInformacoesClientePf, ...api }
}
